import React from 'react';
import { StructuredData } from './StructuredData';
/** Renders structured product data using Schema.org vocab */
const StructuredCategoryData = ({ category, extraFields = {} }) => {
    var _a, _b, _c, _d;
    const baseCollectionPageData = {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: category.name,
        description: category.content,
        primaryImageOfPage: (_b = (_a = category.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url,
        image: (_d = (_c = category.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url
    };
    const withInjectedCategoryData = Object.assign(Object.assign({}, baseCollectionPageData), extraFields);
    return React.createElement(StructuredData, { json: withInjectedCategoryData });
};
export { StructuredCategoryData };
//# sourceMappingURL=StructuredCategoryData.js.map